module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};



//////////////////
// WEBPACK FOOTER
// /opt/jenkins_home/workspace/marketing-campaigns_deploy_trigger_imp/3832/lib/node_modules/@core/macys-cli/node_modules/core-js/modules/_fails.js
// module id = 3
// module chunks = 0